import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // Importez le router

const app = createApp(App)
app.use(router) // Utilisez le router dans l'application
app.mount('#app')
